export const NEW_EMAIL_UPDATE_SELECTED_TEMPLATE = 'NEW_EMAIL_UPDATE_SELECTED_TEMPLATE';
export const NEW_EMAIL_UPDATE_SELECTED_TEMPLATE_RESET = 'NEW_EMAIL_UPDATE_SELECTED_TEMPLATE_RESET';
export const NEW_EMAIL_SET_TEMPLATES = 'NEW_EMAIL_SET_TEMPLATES';
export const NEW_EMAIL_RESET_TEMPLATES = 'NEW_EMAIL_RESET_TEMPLATES';
export const NEW_EMAIL_TEMPLATES_PAGENATIONS = 'NEW_EMAIL_TEMPLATES_PAGENATIONS';
export const UPDATE_EMAIL_TEMPLATE_CONTENT = 'UPDATE_EMAIL_TEMPLATE_CONTENT';



// WEBPACK FOOTER //
// ./src/views/email/newEmail/flow/actionType.js